"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const storage = __importStar(require("./storage"));
const pulseStorageKeys = {
    PULSE_PPID_STORAGE_KEY: '_pulse.internal.identity.ppid',
    PULSE_CIS_CACHE_STORAGE_KEY: '_pulse.internal.identity.cis',
};
const getPPIDsFromStorage = () => {
    var _a;
    try {
        const webStorage = storage.getStorage();
        return JSON.parse((_a = webStorage.getItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY)) !== null && _a !== void 0 ? _a : '');
    }
    catch (err) {
        return {};
    }
};
const setPPIDsToStorage = (ppid) => {
    try {
        const webStorage = storage.getStorage();
        webStorage.setItem(pulseStorageKeys.PULSE_PPID_STORAGE_KEY, JSON.stringify(ppid));
        return true;
    }
    catch (err) {
        return false;
    }
};
const getCisCacheFromStorage = () => {
    var _a;
    try {
        const webStorage = storage.getStorage();
        return JSON.parse((_a = webStorage.getItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY)) !== null && _a !== void 0 ? _a : '');
    }
    catch (err) {
        return {};
    }
};
const setCisCacheToStorage = (cisPayload) => {
    try {
        const webStorage = storage.getStorage();
        webStorage.setItem(pulseStorageKeys.PULSE_CIS_CACHE_STORAGE_KEY, JSON.stringify(cisPayload));
        return true;
    }
    catch (err) {
        return false;
    }
};
exports.default = {
    getCisCacheFromStorage,
    setCisCacheToStorage,
    getPPIDsFromStorage,
    setPPIDsToStorage,
};
//# sourceMappingURL=pulseStorage.js.map